import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/taxonomies/validation-rules',
)({
  loader: () => ({ breadcrumbTitle: 'Validation Rules' }),
})
